import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import './App.css';
export default function Layout({ children, menu, categories, brands }) {
  return (
    <div className="d-flex flex-column min-vh-100">

      {/* HEADER */}
      <Header menu={menu} />

      {/* MAIN CONTENT */}
      <main className="flex-grow-1">
        {children}
      </main>

      {/* FOOTER */}
      <Footer categories={categories} brands={brands} />

    </div>
  );
}
